import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.scss';

const AuthLayout: React.FC = () => {
  return (
    <div className={styles.authLayout}>
      <Outlet />
      <footer className={styles.authLayoutFooter}>
        <div className={styles.authLayoutFooterContent}>
          <div className={styles.authLayoutFooterContentLeft}>
            <a href="https://www.gigg.com/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
